export default {
  errorDefault: 'Ocorreu um erro',
  unknown: 'Desconhecido',
};